import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import selectors from './ClinicSelectors';

const trackMapExpand = () => {
	window.dataLayer.push({
		event: 'view_map',
	});
};

const onHideMap = () => {
	enableBodyScroll(selectors.ELEMENTS.mapContainerEle);
	selectors.ELEMENTS.showMapTrigger.classList.remove(selectors.CLASSES.displayNone);
	selectors.ELEMENTS.mapContainerEle.classList.remove(selectors.CLASSES.showMap);
	selectors.ELEMENTS.listContainerEle.classList.remove(selectors.CLASSES.hideList);
	selectors.ELEMENTS.showListTrigger.classList.add(selectors.CLASSES.displayNone);
	selectors.ELEMENTS.triggersContainer.classList.remove(selectors.CLASSES.borderNone);
};

const onShowMap = () => {
	disableBodyScroll(selectors.ELEMENTS.mapContainerEle);
	selectors.ELEMENTS.showListTrigger.classList.remove(selectors.CLASSES.displayNone);
	selectors.ELEMENTS.mapContainerEle.classList.add(selectors.CLASSES.showMap);
	selectors.ELEMENTS.listContainerEle.classList.add(selectors.CLASSES.hideList);
	selectors.ELEMENTS.showMapTrigger.classList.add(selectors.CLASSES.displayNone);
	selectors.ELEMENTS.triggersContainer.classList.add(selectors.CLASSES.borderNone);
	trackMapExpand();
};

export default {
	onHideMap,
	onShowMap,
};
